import React, { FC, useState, useCallback } from "react"
import "./index.scss"
type TItem = { name: string; key: string }
type TTab = {
  list: TItem[]
  onClick?: (item: TItem, index: number) => void
}
const Tab: FC<TTab> = ({ list = [], onClick }) => {
  const [current, setCurrent] = useState("0")
  const clickItem = useCallback(
    (item: TItem, index) => {
      setCurrent(item.key)
      onClick && onClick(item, index)
    },
    [setCurrent, onClick]
  )
  return (
    <div className="cm-tab">
      {list.map((tab, i) => {
        return (
          <div
            className={current === tab.key ? "active" : ""}
            key={tab.key}
            onClick={() => clickItem(tab, i)}
          >
            <div className="tab-border"></div>
            <span>{tab.name}</span>
          </div>
        )
      })}
    </div>
  )
}

export default Tab
